import { useGameImage } from '@/hooks/useGameImage';
import type { Game } from '@/models/game';

export const GameImage = ({ game }: { game: Game }) => {
  const { getGameImage } = useGameImage();

  return (
    <img
      draggable={false}
      className="w-full max-h-48 object-cover rounded-sm"
      alt={game.name}
      src={game.image ?? getGameImage(game.game_code)}
    />
  );
};
